
<template>
<a-form-model-item
    label="联系人地址"
    :label-col="{span: 3}"
    :wrapper-col="{span: 21}"
    :prop="propStr"
>
    <AddressDetail
    :default-province="defaultProvince"
    :default-address="defaultAddress"
    @updateAddress="updateAddress"
    @updateData="onChange" />
</a-form-model-item>
</template>

<script>
import AddressDetail from "@/components/app-get-address-details";
import minix from './minix'

export default {
    components: {
        AddressDetail
    },
    mixins: [minix],
    model: {
        prop: 'address',
        event: 'change'
    },
    props: {
        address: {
            type: Object,
            default() {
                return {
                    provinceName: '',
                    provinceCode: '',
                    cityName: '',
                    cityCode: '',
                    countyName: '',
                    countyCode: '',
                    address: ''
                }
            }
        },
        propName: {
            type: String,
            default: 'address'
        },
    },
    data () {
        return {
            rules: [
                { required: true, message: '请选择地址', trigger: 'change' },
            ]
        }
    },
    computed: {
        defaultProvince() {
            return [
                this.address.provinceCode,
                this.address.cityCode,
                this.address.countyCode
            ]
        },
        defaultAddress() {
            return this.address.address
        }
    },
    methods: {
        updateAddress(addText) {
            this.$emit('change', {
                ...this.address,
                address: addText,
            })
        },
        onChange(address) {
            this.$emit('change', {
                ...address,
                address: address.name,
                origAddress: address.origAddress,
                provinceName: address.province,
                cityName: address.city,
                countyName: address.county,
            })
        }
    },
}
</script>
